export default __webpack_public_path__ + "static/media/imperialClosed.75c81db6.jpg";